import script from "./TurboTradeChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TurboTradeChart.vue?vue&type=script&setup=true&lang=js"

import "./TurboTradeChart.vue?vue&type=style&index=0&id=5403180f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5403180f"]])

export default __exports__